import { TeacherBooksPage } from "@/pages/teacher/TeacherBooksPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/books/")({
  component: TeacherBooksPage,
});
